import vuetify from 'www/modules/vuetify-plugin'
import { deepMerge } from 'www/utils'

function getComponentConfig(overrides = {}) {
  const config = {
    vuetify,
  }

  return deepMerge(config, overrides)
}

export default getComponentConfig
